import { Fragment, useMemo } from 'react';
import classNames from 'classnames';
import ArrowIcon from '../icons/ArrowIcon';

interface IProps {
  pagesCount: number;
  currentPageNumber: number;
  onPageChange: (pageNumber: number) => () => void;
}

const PaginationBtns = ({
  pagesCount,
  currentPageNumber,
  onPageChange,
}: IProps) => {
  const PageNumberBtn = ({ num }: { num: number }) => {
    return (
      <div
        className={classNames('filings__table--pagination__btn', {
          'btn-active': num === currentPageNumber,
        })}
        onClick={onPageChange(num)}
      >
        {num}
      </div>
    );
  };

  const pageNumbers = useMemo(() => {
    let pageNumsResult: number[][] = [
      Array.from({ length: pagesCount }, (_, i) => i + 1),
    ];

    if (pagesCount > 30) {
      const midOfArr = Number((pagesCount / 2).toFixed());

      const firstPagesNumArr = [1, 2, 3];
      const middlePagesNumArr = [midOfArr - 1, midOfArr, midOfArr + 1];
      const lastPagesNumArr = [pagesCount - 2, pagesCount - 1, pagesCount];
      const currentPagesNumArr = Array.from(
        { length: 5 },
        (_, i) => currentPageNumber - 2 + i,
      ).filter((pageNum) => pageNum > 0 && pageNum <= pagesCount);

      const isFirstNumArrOverlapCurrentArr =
        firstPagesNumArr[firstPagesNumArr.length - 1] - currentPagesNumArr[0] >=
        -1;
      const isLastNumArrOverlapCurrentArr =
        lastPagesNumArr[0] -
          currentPagesNumArr[currentPagesNumArr.length - 1] <=
        1;

      if (isFirstNumArrOverlapCurrentArr) {
        const mergedFirstAndCurrentPagesNumArr = Array.from(
          new Set([...firstPagesNumArr, ...currentPagesNumArr]),
        ).sort();

        pageNumsResult = [
          mergedFirstAndCurrentPagesNumArr,
          middlePagesNumArr,
          lastPagesNumArr,
        ];
      } else if (isLastNumArrOverlapCurrentArr) {
        const mergedLastAndCurrentPagesNumArr = Array.from(
          new Set([...currentPagesNumArr, ...lastPagesNumArr]),
        ).sort();

        pageNumsResult = [
          firstPagesNumArr,
          middlePagesNumArr,
          mergedLastAndCurrentPagesNumArr,
        ];
      } else {
        pageNumsResult = [
          firstPagesNumArr,
          currentPagesNumArr,
          lastPagesNumArr,
        ];
      }
    }
    return pageNumsResult;
  }, [pagesCount, currentPageNumber]);

  return (
    <div className="filings__table--pagination__container">
      {pageNumbers.map((arr, index) => (
        <Fragment key={arr.toString()}>
          {index !== 0 && (
            <span className="filings__table--pagination__separator">...</span>
          )}
          {arr.map((number) => (
            <PageNumberBtn num={number} key={number} />
          ))}
        </Fragment>
      ))}
      {Boolean(currentPageNumber !== pagesCount && pagesCount) && (
        <div
          className="filings__table--pagination__next-btn"
          onClick={onPageChange(currentPageNumber + 1)}
        >
          <ArrowIcon />
        </div>
      )}
    </div>
  );
};

export default PaginationBtns;
